import React, { Fragment } from "react";

export default function Toc(props) {
  const { lines, index } = props;
  return (
    <div className="toc">
      <div className="item-number">{index}.</div>
      <ul>
        {lines.map(line => (
          <Entry key={line.number} {...line} />
        ))}
      </ul>
    </div>
  );
}

function Entry({ number, text, children }) {
  return (
    <li key={number}>
      {!!text && (
        <Fragment>
          <span className="number">{number}</span>{" "}
          <span className="text">
            {text.includes("*") ? italicize(text) : text}
          </span>
        </Fragment>
      )}
      {!!children && <ul>{children.map(Entry)}</ul>}
    </li>
  );
}

function italicize(text) {
  return text
    .split("*")
    .map((d, i) => (i % 2 ? <em key={i}>{d}</em> : d))
    .filter(d => d);
}
